import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';
import Backend from 'i18next-http-backend';

const initPromise = i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    react: {
      useSuspense: false
    },
    backend: {
      loadPath: () => {
        const prefix = '/food/onboarding';
        return `${prefix}/locales/{{lng}}/{{ns}}.json`;
      }
    }
  });

export { initPromise };
export default i18n;
